import React, { useEffect, useState } from 'react'
import { useTranslation } from 'language/translator'

import { ThemeProvider } from '@mui/material'
import { getTheme } from 'themes'

import Button from 'components_new/atoms/Button'
import SimpleDialog from 'components_new/molecules/SimpleDialog'
import Box from 'components_new/atoms/Box'
import { FunnelStage } from 'types/GlobalWidget'
import { cloneDeep } from 'lodash'
import ReOrderItem from '../ReOrderItem'
import DndList from 'components_new/molecules/DndList'
import { TPutFunnelStages } from 'redux/api/Widgets/types'

interface EditDialogProps {
  funnelStages: FunnelStage[]
  updateEvents: (data: TPutFunnelStages) => void
  onClose: () => void
  open: boolean
}

const convertTitle = (title: string | null, missingTitle: string) =>
  title || missingTitle

const EditDialog = (props: EditDialogProps) => {
  const { funnelStages, onClose, open, updateEvents } = props

  const [tempEvents, setTempEvents] = useState<FunnelStage[]>([])

  useEffect(() => {
    setTempEvents(funnelStages.map((value) => ({ ...value })))
  }, [funnelStages])

  const { t } = useTranslation()
  const missingTitle = t('global', 'missing_value')
  const handleUpdate = () => {
    const data = tempEvents.map((event) => ({
      status: event.status,
      hidden: event.hidden,
      title: event.title
    }))

    updateEvents(data)
    onClose()
  }

  const handleCancel = () => {
    setTempEvents(funnelStages.map((value) => ({ ...value })))
    onClose()
  }

  return (
    <ThemeProvider theme={getTheme('light')}>
      <SimpleDialog
        title={t('global', 'edit_order')}
        open={open}
        onClose={handleCancel}
        actions={
          <>
            <Button variant="text" onClick={handleCancel}>
              {t('global', 'cancel')}
            </Button>
            <Button onClick={handleUpdate} variant="contained">
              {t('global', 'save')}
            </Button>
          </>
        }
        sx={{ zIndex: 1400 }}
      >
        <Box
          sx={{
            width: '100%',
            flexGrow: 1,
            minWidth: 0,
            overflow: 'hidden'
          }}
        >
          <DndList
            editable={true}
            handleDragEnd={(newOrder) => {
              setTempEvents(
                newOrder.map(
                  (title) =>
                    funnelStages.find(
                      (fs) =>
                        convertTitle(fs.title, missingTitle) ===
                        convertTitle(title, missingTitle)
                    ) as FunnelStage
                )
              )
            }}
            horizontal={true}
            itemGap={0}
            itemHeight={40}
            items={tempEvents.map((item, i) => {
              return {
                disabled: false,
                id: convertTitle(item.title, missingTitle),
                content: (
                  <Box
                    key={convertTitle(item.title, missingTitle)}
                    sx={{
                      height: '100%',
                      minHeight: 100,
                      width: '100%',
                      minWidth: 0,
                      p: 0.5
                    }}
                  >
                    <ReOrderItem
                      editable={true}
                      hidden={item.hidden}
                      setHidden={(hidden) => {
                        const newEvents = cloneDeep(tempEvents)

                        newEvents[i].hidden = hidden

                        setTempEvents(newEvents)
                      }}
                      status={item.status}
                      setStatus={(status) => {
                        const newEvents = cloneDeep(tempEvents)

                        newEvents[i].status = status

                        setTempEvents(newEvents)
                      }}
                      title={convertTitle(item.title, missingTitle)}
                    />
                  </Box>
                )
              }
            })}
            sx={{ overflow: 'scroll' }}
          />
        </Box>
      </SimpleDialog>
    </ThemeProvider>
  )
}

export default EditDialog
